import { ButtonHTMLAttributes, forwardRef } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'ghost' | 'oxblood';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  trailing?: string;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', trailing, className, children, ...rest },
  ref,
) {
  const cls = [styles.btn, styles[variant], className].filter(Boolean).join(' ');
  return (
    <button ref={ref} className={cls} {...rest}>
      <span className={styles.label}>{children}</span>
      {trailing ? <span className={styles.arrow}>{trailing}</span> : null}
    </button>
  );
});
